import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
query getBenchmarkReports {
  benchmarkReports {
    reports {
      name
      points {
        date
        value
      }
    }
  }
}
`

export const benchmarkReportsKey = getQueryNames(query)[0]

export default query
